/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';

const totalFacingsDataSelector = state => state.merchandising.totalFacingsData;

export const shouldRenderTotalFacingsChart = createSelector(
  totalFacingsDataSelector,
  totalFacingsData => totalFacingsData && totalFacingsData.length > 0,
);
